function stringifyISODate(date: string): string {
  return new Date(date).toLocaleString();
}

export default {
  stringifyISODate,
};
